import React, { useMemo } from "react";
import { makeStyles, Box, Typography } from "@material-ui/core";
import { getLang } from "app/feature/constants";
import RefreshTable from "components/table/refreshTable";
import { Skeleton } from "@material-ui/lab";
import TngCard from "assets/img/tngCard.png";
import { currencies } from "lib/constants/currency";

const useStyle = makeStyles((theme) => ({
  logo: {
    width: "100%",
    maxHeight: "500px",
    objectFit: "contain",
  },
  label: {
    color: "#707987",
  },
  field: {
    display: "grid",
    gridTemplateColumns: "4fr 5fr",
    alignItems: "center",
    "&:not(first-child)": {
      marginBottom: 16,
    },
  },
}));

export default function CreditBalanceOverviewPanelComponent({
  lang,
  isFetching,
  isError,
  handleReload,
  disbursementInfo,
  overview,
}) {
  const classes = useStyle();

  const exp = useMemo(() => {
    if (disbursementInfo?.currency) {
      return (
        currencies.find((c) => c.alpha3 === disbursementInfo.currency)?.exp ?? 2
      );
    }
    return 2;
  }, [disbursementInfo]);

  return (
    <Box>
      <Box mb={0.5}>
        <Typography variant="body1">
          <b>{getLang(lang, "label.OVERVIEW")}</b>
        </Typography>
      </Box>
      {isFetching ? (
        <>
          <Skeleton variant="text" animation="wave" height={25} />
          <Skeleton variant="text" animation="wave" height={25} />
          <Skeleton variant="text" animation="wave" height={25} />
          <Skeleton variant="text" animation="wave" height={25} />
        </>
      ) : isError ? (
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <RefreshTable handleReload={handleReload} />
        </Box>
      ) : (
        <>
          <Box>
            <img src={TngCard} alt="tng" className={classes.logo} />
          </Box>
          <Box>
            <Box className={classes.field}>
              <Typography variant="body2" className={classes.label}>
                <b>{getLang(lang, "label.CURRENT_BALANCE")}</b>
              </Typography>
              <Typography
                variant="h5"
                style={{ color: "#6184FF" }}
                align="right"
              >
                <b>
                  {disbursementInfo.currency}
                  {" "}
                  {overview.creditBalances.current.credit.toLocaleString(
                    "en-US",
                    {
                      minimumFractionDigits: exp,
                      maximumFractionDigits: exp,
                    }
                  )}
                </b>
              </Typography>
            </Box>
            <Box className={classes.field}>
              <Typography variant="body2" className={classes.label}>
                <b>{getLang(lang, "label.UNALLOCATED_CREDIT")}</b>
              </Typography>
              <Typography
                variant="h5"
                style={{ color: "#6AAF68" }}
                align="right"
              >
                <b>
                  {disbursementInfo.currency}
                  {" "}
                  {overview.creditBalances.unallocated.credit.toLocaleString(
                    "en-US",
                    {
                      minimumFractionDigits: exp,
                      maximumFractionDigits: exp,
                    }
                  )}
                </b>
              </Typography>
            </Box>
            <Box className={classes.field}>
              <Typography variant="body2" className={classes.label}>
                <b>{getLang(lang, "label.ALLOCATED_CREDIT")}</b>
              </Typography>
              <Typography
                variant="h5"
                style={{ color: "#F04438" }}
                align="right"
              >
                <b>
                  {disbursementInfo.currency}
                  {" "}
                  {overview.creditBalances.allocated.credit.toLocaleString(
                    "en-US",
                    {
                      minimumFractionDigits: exp,
                      maximumFractionDigits: exp,
                    }
                  )}
                </b>
              </Typography>
            </Box>
            <Box className={classes.field}>
              <Typography variant="body2" className={classes.label}>
                <b>{getLang(lang, "label.ACTIVE_CAMPAIGN")}</b>
              </Typography>
              <Typography
                variant="h5"
                style={{ color: "#7F56D9" }}
                align="right"
              >
                <b>{overview.activeCampaign.toLocaleString("en-US")}</b>
              </Typography>
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
}
